import { splitShipmentDiscountSchema } from "@redotech/redo-fulfillment-settings/split-shipment-discount";
import { unaryRpc } from "@redotech/rpc/definition";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getSplitShipmentDiscount = unaryRpc({
  name: "getSplitShipmentDiscount" as const,
  input: z.object({ teamId: zExt.objectId() }),
  output: z.object({
    available: z.boolean(),
    settings: splitShipmentDiscountSchema,
  }),
});
